<template>
  <Modal v-model="openMap" :title="mapData.address" footer-hide width="800">
    <div id="reportMap"></div>
  </Modal>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openMap: false,
      mapData: {
        address: "",
        lng: "",
        lat: "",
      },
    };
  },
  methods: {
    open(v) {
      this.mapData = v;
      this.openMap = true;
      this.gMap();
      this.convert();
    },
    gMap(point) {
      var map = new AMap.Map("reportMap", {
        resizeEnable: true,
        center: point,
        zoom: 13,
        defaultCursor: "",
      });
      var Marker = new AMap.Marker({
        position: point,
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png",
      });
      map.add(Marker);
    },
    convert() {
      this.utils.loading(this, "加载中");
      let params = {
        orgCoord: 1,
        pointList: [
          {
            x: this.mapData.lng,
            y: this.mapData.lat,
          },
        ],
        returnCoord: 2,
      };
      this.axios({
        method: "post",
        url: this.axios.lbs + "/lbs/convert",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          if (res) {
            var data = res.data.data[0];
            var point = [data.x, data.y];
            this.gMap(point);
          }
        }
      });
    },
  },
};
</script>
<style lang="">
#reportMap {
  width: 100%;
  height: 400px;
  background: red;
}
</style>


// WEBPACK FOOTER //
// src/components/map/map.vue